import { useEffect, useState } from 'react';

import { screenSize } from '../Themes/sizes';

const useIsMobile = (): boolean => {
  const query = `(max-width: ${screenSize.mobile}px)`;

  // Initialize with actual value on client to prevent flickering on mobile refresh
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    let cleanup: (() => void) | undefined;

    if (typeof window !== 'undefined') {
      const mql = window.matchMedia(query);
      const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

      if (mql.addEventListener) mql.addEventListener('change', onChange);
      else mql.addListener(onChange);

      setIsMobile(mql.matches);

      cleanup = () => {
        if (mql.removeEventListener) mql.removeEventListener('change', onChange);
        else mql.removeListener(onChange);
      };
    }

    return () => {
      if (cleanup) cleanup();
    };
  }, [query]);

  return isMobile;
};

export default useIsMobile;
